import { render, staticRenderFns } from "./DealershipKits.vue?vue&type=template&id=62cf52ff&"
import script from "./DealershipKits.vue?vue&type=script&lang=js&"
export * from "./DealershipKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports